import { api } from '../api';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const USERLIST = 'USERLIST';
export const USERFORM = 'USERFORM';
export const APPLICATIONSETTING = 'APPLICATIONSETTING';
export const UPDATETHEME = 'UPDATETHEME';
export const LICENSELIST = 'LICENSELIST';
export const LICENSEFORM = 'LICENSEFORM';
export const RESETPASSWORD = 'RESETPASSWORD';
export const RESETPASSWORD_RESET = 'RESETPASSWORD_RESET';
export const RESETPASSWORDREQ = 'RESETPASSWORDREQ';
export const RESETPASSWORDREQ_RESET = 'RESETPASSWORDREQ_RESET';
export const FACILITYFORM = 'FACILITYFORM';
export const FACILITYFORM_RESET = 'FACILITYFORM_RESET';
export const EQUIPMENTFROM = 'EQUIPMENTFROM';
export const EQUIPMENTLIST = 'EQUIPMENTLIST';
export const HISTORYLIST = 'HISTORYLIST';
export const PREFERENCEFORM = 'PREFERENCEFORM';
export const PREFERENCEFORM_RESET = 'PREFERENCEFORM_RESET';
export const PREFERENCELIST = 'PREFERENCELIST';
export const REPORTFORM = 'REPORTFORM';
export const GENERATEREPORT = 'GENERATEREPORT';
export const COMBOTYPES = 'COMBOTYPES';
export const COMBOTYPES_SUCCESS = 'COMBOTYPES_SUCCESS';
export const TESTACCESSLOCATION = 'TESTACCESSLOCATION';
export const TESTACCESSLOCATION_SUCCESS = 'TESTACCESSLOCATION_SUCCESS';
export const TESTACCESSLOCATION_RESET = 'TESTACCESSLOCATION_RESET';
export const MODELFORM = 'MODELFORM';
export const MODELLIST = 'MODELLIST';
export const COUNTRIES = 'COUNTRIES';
export const TRACKING_SYSTEM_LIST = 'TRACKING_SYSTEM_LIST';
export const TRACKING_SYSTEM_FORM = 'TRACKING_SYSTEM_FORM';
export const TRACKING_SYSTEM_FORM_RESET = 'TRACKING_SYSTEM_FORM_RESET';
export const TRACKING_SYSTEM_LIST_RESET = 'TRACKING_SYSTEM_LIST_RESET';
export const SORTORDERFORM = 'SORTORDERFORM';
export const SORTORDERFORMRESET = 'SORTORDERFORMRESET';
export const SORTORDERLIST = 'SORTORDERLIST';
export const CAT_SOFTWARE_VERSION_LIST = 'CAT_SOFTWARE_VERSION_LIST';
export const CAT_SOFTWARE_VERSION_FORM = 'CAT_SOFTWARE_VERSION_FORM';
export const CAT_SOFTWARE_VERSION_FORM_RESET =
  'CAT_SOFTWARE_VERSION_FORM_RESET';
export const CAT_SOFTWARE_VERSION_LIST_RESET =
  'CAT_SOFTWARE_VERSION_LIST_RESET';
export const TRACKING_SYSTEM_CONTACT_LIST = 'TRACKING_SYSTEM_CONTACT_LIST';
export const TRACKING_SYSTEM_CONTACT_FORM = 'TRACKING_SYSTEM_CONTACT_FORM';
export const TRACKING_SYSTEM_CONTACT_FORM_RESET =
  'TRACKING_SYSTEM_CONTACT_FORM_RESET';
export const TRACKING_SYSTEM_CONTACT_LIST_RESET =
  'TRACKING_SYSTEM_CONTACT_LIST_RESET';

export function login(data = {}, options = {}) {
  return {
    type: options.type || LOGIN,
    apiMethod: options.apiMethod || 'POST',
    isFromLoginPage: options.isFromLoginPage || false,
    apiUrl: api.Login,
    data
  };
}

export function logout(data = {}, options = {}) {
  return {
    type: options.type || LOGOUT,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.Logout,
    data
  };
}

export function userList(data = {}, options = {}) {
  return {
    type: options.type || USERLIST,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.User,
    data
  };
}

export function userForm(data = {}, options = {}) {
  return {
    type: options.type || USERFORM,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.User,
    data
  };
}

export function licenseList(data = {}, options = {}) {
  return {
    type: options.type || LICENSELIST,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.License,
    data
  };
}

export function licenseForm(data = {}, options = {}) {
  return {
    type: options.type || LICENSEFORM,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.License,
    data
  };
}

export function updateTheme(data = {}, options = {}) {
  return {
    type: options.type || UPDATETHEME,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.updateTheme,
    data
  };
}

export function resetPassword(data = {}, options = {}) {
  return {
    type: options.type || RESETPASSWORD,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.ResetPassword,
    data
  };
}
export function resetPasswordReq(data = {}, options = {}) {
  return {
    type: options.type || RESETPASSWORDREQ,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.ResetPasswordReq,
    data
  };
}

export function facilityForm(data = {}, options = {}) {
  return {
    type: options.type || FACILITYFORM,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.Facility,
    data
  };
}

export function facilityFormReset() {
  return {
    type: FACILITYFORM_RESET
  };
}

export function equipmentForm(data = {}, options = {}) {
  return {
    type: options.type || EQUIPMENTFROM,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.Equipment,
    data
  };
}

export function equipmentList(data = {}, options = {}) {
  return {
    type: options.type || EQUIPMENTLIST,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.Equipment,
    data
  };
}

export function historyList(data = {}, options = {}) {
  return {
    type: options.type || HISTORYLIST,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.History,
    data
  };
}

export function preferenceForm(data = {}, options = {}) {
  return {
    type: options.type || PREFERENCEFORM,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.Preference,
    data
  };
}

export function preferenceList(data = {}, options = {}) {
  return {
    type: options.type || PREFERENCELIST,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.Preference,
    data
  };
}

export function reportForm(data = {}, options = {}) {
  return {
    type: options.type || REPORTFORM,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.Report,
    data
  };
}

export function generateReport(data = {}, options = {}) {
  return {
    type: options.type || GENERATEREPORT,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.GenerateReport,
    data
  };
}

export function testAccessLocation(data = {}, options = {}) {
  return {
    type: options.type || TESTACCESSLOCATION,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.testAccessLocation,
    data
  };
}

export function comboTypes(data = {}, options = {}) {
  return {
    type: options.type || COMBOTYPES,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.comboType,
    data
  };
}

export function modelForm(data = {}, options = {}) {
  return {
    type: options.type || MODELFORM,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.Model,
    data
  };
}

export function modelList(data = {}, options = {}) {
  return {
    type: options.type || MODELLIST,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.Model,
    data
  };
}
export function countriesList(data = {}, options = {}) {
  return {
    type: options.type || COUNTRIES,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.Countries,
    data
  };
}

//local action
export function applicationSetting(data = {}) {
  return {
    type: APPLICATIONSETTING,
    data
  };
}

export function preferenceFormReset() {
  return {
    type: PREFERENCEFORM_RESET
  };
}

export function resetPasswordReset() {
  return {
    type: RESETPASSWORD_RESET
  };
}

export function resetPasswordReqReset() {
  return {
    type: RESETPASSWORDREQ_RESET
  };
}

export function testAccessLocationReset() {
  return {
    type: TESTACCESSLOCATION_RESET
  };
}

export function trackingSystemList(data = {}, options = {}) {
  return {
    type: options.type || TRACKING_SYSTEM_LIST,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.TrackingSystem,
    data
  };
}

export function trackingSystemForm(data = {}, options = {}) {
  return {
    type: options.type || TRACKING_SYSTEM_FORM,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.TrackingSystem,
    data
  };
}

export function trackingSystemFormReset() {
  return {
    type: TRACKING_SYSTEM_FORM_RESET
  };
}

export function trackingSystemListReset() {
  return {
    type: TRACKING_SYSTEM_LIST_RESET
  };
}
/**
 * Creates an action to submit a sort order form.
 *
 * @param {Object} [data={}] - The request payload for the sort order form.
 * @param {Object} [options={}] - Optional overrides for the action.
 * @param {string} [options.type] - Custom action type (defaults to SORTORDERFORM).
 * @param {string} [options.apiMethod] - HTTP method (defaults to 'POST').
 * @returns {Object} Redux action object.
 */
export function sortOrderForm(data = {}, options = {}) {
  return {
    type: options.type || SORTORDERFORM,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.sortOrder,
    data
  };
}

/**
 * Creates an action to fetch the sort order list.
 *
 * @param {Object} [data={}] - The request payload for fetching the list.
 * @param {Object} [options={}] - Optional overrides for the action.
 * @param {string} [options.type] - Custom action type (defaults to SORTORDERLIST).
 * @param {string} [options.apiMethod] - HTTP method (defaults to 'POST').
 * @returns {Object} Redux action object.
 */
export function sortOrderList(data = {}, options = {}) {
  return {
    type: options.type || SORTORDERLIST,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.sortOrder,
    data
  };
}

/**
 * Creates an action to reset the sort order form.
 *
 * @returns {Object} Redux action object.
 */
export function sortOrderFormReset() {
  return {
    type: SORTORDERFORMRESET
  };
}

/**
 * Creates an action to fetch the CAT software version list.
 *
 * @param {Object} [data={}] - The request payload for fetching the list.
 * @param {Object} [options={}] - Optional overrides for the action.
 * @param {string} [options.type] - Custom action type (defaults to CAT_SOFTWARE_VERSION_LIST).
 * @param {string} [options.apiMethod] - HTTP method (defaults to 'POST').
 * @returns {Object} Redux action object.
 */
export function catSoftwareVersionList(data = {}, options = {}) {
  return {
    type: options.type || CAT_SOFTWARE_VERSION_LIST,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.catSoftwareVersion,
    data
  };
}

/**
 * Creates an action to submit a CAT software version form.
 *
 * @param {Object} [data={}] - The request payload for the form.
 * @param {Object} [options={}] - Optional overrides for the action.
 * @param {string} [options.type] - Custom action type (defaults to CAT_SOFTWARE_VERSION_FORM).
 * @param {string} [options.apiMethod] - HTTP method (defaults to 'POST').
 * @returns {Object} Redux action object.
 */
export function catSoftwareVersionForm(data = {}, options = {}) {
  return {
    type: options.type || CAT_SOFTWARE_VERSION_FORM,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.catSoftwareVersion,
    data
  };
}

/**
 * Creates an action to reset the CAT software version form.
 *
 * @returns {Object} Redux action object.
 */
export function catSoftwareVersionFormReset() {
  return {
    type: CAT_SOFTWARE_VERSION_FORM_RESET
  };
}

/**
 * Creates an action to reset the CAT software version list.
 *
 * @returns {Object} Redux action object.
 */
export function catSoftwareVersionListReset() {
  return {
    type: CAT_SOFTWARE_VERSION_LIST_RESET
  };
}
/**
 * Creates an action for fetching the tracking system contact list.
 *
 * @param {Object} [data={}] - The request payload data.
 * @param {Object} [options={}] - Optional overrides for action properties.
 * @param {string} [options.type] - Custom action type (defaults to TRACKING_SYSTEM_CONTACT_LIST).
 * @param {string} [options.apiMethod] - HTTP method (defaults to 'POST').
 * @param {string} [options.apiUrl] - API URL (defaults to api.trackingSystemContact).
 * @returns {Object} The Redux action object.
 */
export function trackingSystemContactList(data = {}, options = {}) {
  return {
    type: options.type || TRACKING_SYSTEM_CONTACT_LIST,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.trackingSystemContact,
    data
  };
}

/**
 * Creates an action for submitting the tracking system contact form.
 *
 * @param {Object} [data={}] - The request payload data.
 * @param {Object} [options={}] - Optional overrides for action properties.
 * @param {string} [options.type] - Custom action type (defaults to TRACKING_SYSTEM_CONTACT_FORM).
 * @param {string} [options.apiMethod] - HTTP method (defaults to 'POST').
 * @param {string} [options.apiUrl] - API URL (defaults to api.trackingSystemContact).
 * @returns {Object} The Redux action object.
 */
export function trackingSystemContactForm(data = {}, options = {}) {
  return {
    type: options.type || TRACKING_SYSTEM_CONTACT_FORM,
    apiMethod: options.apiMethod || 'POST',
    apiUrl: api.trackingSystemContact,
    data
  };
}

/**
 * Creates an action to reset the tracking system contact form state.
 *
 * @returns {Object} The Redux action object.
 */
export function trackingSystemContactFormReset() {
  return {
    type: TRACKING_SYSTEM_CONTACT_FORM_RESET
  };
}

/**
 * Creates an action to reset the tracking system contact list state.
 *
 * @returns {Object} The Redux action object.
 */
export function trackingSystemContactListReset() {
  return {
    type: TRACKING_SYSTEM_CONTACT_LIST_RESET
  };
}
